import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { GlobalSpinnerService } from '../loader-service/global-spinner.service';
import { ConsumableAdstxtRecord } from '../../domain/consumable-adstxt-record.model';
import { Domain } from '../../domain/domain.model';
import { AdsTxtStatus } from '../../domain/adstxt-status.model';
import { ClipboardService } from 'ngx-clipboard';
import { SnackBarService } from '../../services/snackbar.service';

@Component({
  selector: 'cm-adstxtdiff-dialog',
  templateUrl: 'adstxt-diff-dialog.component.html',

})
export class AdstxtDiffDialogComponent implements OnInit {

  public diff: AdsTxtDiff;
  public domain: Domain;
  AdsTxtStatus = AdsTxtStatus;
  selectedIndex = 0;

  constructor(public dialogRef: MatDialogRef<AdstxtDiffDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { showComment: boolean, domain: Domain, result: AdsTxtDiff },
              private snackBarService: SnackBarService,
              private clipboardService: ClipboardService,
              private spinnerService: GlobalSpinnerService,
              private httpClient: HttpClient) {
    this.domain = data.domain;

    if (!data.result) {
      spinnerService.showLoader();
      httpClient.get<AdsTxtDiff>(`${environment.serviceUrl}/ad-stats/publisher-stats/domain/${this.domain.id}/adstxt`)
        .subscribe((next: AdsTxtDiff) => {
          this.diff = next;
          spinnerService.hideLoader();

        }, () => {
          spinnerService.hideLoader();
        });
    } else {
      this.diff = data.result;
    }
  }

  ngOnInit() {
    // this.dialogRef.updateSize('auto', '90%');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  onCopyToClipboard() {
    let contentToCopy = '';

    this.diff.notFound.forEach(element => {
      let comment = '';
      if (element.comment && !this.data.showComment) {
        comment = ' ' + element.comment;
      }
      contentToCopy += element.domain + ', ' + element.publisherAccountId + ', ' + element.accountType + '\n';
    });

    this.clipboardService.copyFromContent(contentToCopy);
    this.snackBarService.success('Copied to clipboard!');
  }

}

export class AdsTxtDiff {
  found: ConsumableAdstxtRecord[];
  notFound: ConsumableAdstxtRecord[];
  recentlyAdded: ConsumableAdstxtRecord[];
  recentlyRemoved: ConsumableAdstxtRecord[];
}
